if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector("[type=\"submit\"]");
        this.productView = this.querySelector(".product__view-details");
        this.ratings = this.querySelector(".product__rating");
        this.accordion = document.querySelector(".image-with-content__block");
        this.reviews = document.querySelector(".accordion__item.product__reviews");
        this.specificationMessage = document.querySelector(".product__specification .js-specification-top");
        this.body = document.querySelector("body");

        this.scrollToTarget(this.productView, this.accordion);

        if (this.specificationMessage) this.scrollToTarget(this.specificationMessage, this.body);
        if (this.ratings) this.scrollToTarget(this.ratings, this.reviews);

        this.updateBreadcrumb();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundaries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundaries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundaries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");

            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundaries();
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden"));
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = ["data-cart-quantity", "data-min", "data-max", "step"];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      scrollToTarget(trigger, target) {
        trigger.addEventListener("click", () => {
          if (target.classList.contains("accordion__item") && !target.classList.contains("accordion__item--open")) {
            const header = target.querySelector(".accordion__header");

            header.click();

            // Wait for the accordion to close — animation duration
            return setTimeout(() => this.scroll(target), 225);
          }

          this.scroll(target);
        });
      }

      scroll(target) {
        const isMobile = window.matchMedia("(max-width: 749px)").matches;
        const stickyBag = document.querySelector(".sticky-bag");
        const stickyActive = stickyBag.classList.contains("sticky-bag--active");
        const targetEnd = target.getBoundingClientRect().top;
        const header = document.documentElement.style.getPropertyValue("--header-height");
        const stickyHeight = isMobile || !stickyActive ? 0 : stickyBag.clientHeight;
        const y = targetEnd - header.replace("px", "") - stickyHeight + window.scrollY;

        window.scrollTo({ top: y, behavior: "smooth" });
      }

      updateBreadcrumb() {
        const collectionVisited = window.sessionStorage.getItem("collectionTag");

        if (collectionVisited) {
          const productTags = JSON.parse(this.dataset.tags);

          productTags.forEach(tag => {
            const collection = JSON.parse(collectionVisited);

            if (tag === collection.tag) {
              const breadcrumb = this.querySelector(".product__breadcrumb");
              const breadcrumbText = breadcrumb.querySelector("span");

              breadcrumb.href = collection.url;
              breadcrumbText.innerHTML = collection.tag;
            }
          });
        }

        window.sessionStorage.setItem("collectionTag", "");
      }
    }
  );
}
